// de_pms_night_audit.ts
// Tłumaczenia dla PMS.NightAudit.tsx

export const dePmsNightAudit = {

  title: "Nachtaudit",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    roomTaxPosting:      "Uebersicht Zimmer- und Steuerbuchungen",
    openBalances:        "Uebersicht offener Salden",
    noShowHandling:      "No-show-Bearbeitung",
    overstayExceptions:  "Ueber- / Unteraufenthaltsausnahmen",
    rateIntegrity:       "Ratenintegritaet / Ausreisser",
    housekeepingSummary: "Housekeeping- / Zimmerverfuegbarkeitsuebersicht",
    finalControl:        "Abschlusskontrolle",
  },

  // ── Przyciski ─────────────────────────────────────────────────────────────
  actions: {
    closeDay:      "Tag schliessen",
    closing:       "Schliessen...",
    opening:       "Oeffnen...",
    createInvoice: "Rechnung erstellen",
    creating:      "Erstellen...",
    downloadPDF:   "PDF herunterladen",
    previewPDF:    "PDF-Vorschau",
    saving:        "Speichern...",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    invoice:          "Rechnung",
    fiscalizedInvoice:"Fiskalische Rechnung",
    nightAuditFolio:  "Nachtaudit-Folio",
    noFolioSelected:  "Kein Folio ausgewaehlt",
    rateOutlier:      "DLX-Preis-Ausreisser",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    invoiceFailed: "Rechnungserstellung fehlgeschlagen.",
  },

} as const;

export default dePmsNightAudit;
